<template>

    <footer class="relative bg-white text-gray-900 pt-32 pb-8 overflow-hidden border-t border-gray-100">
        <!-- Brochure Style Curve (Top) - Matching previous section bg-slate-50 -->
        <!-- <div class="absolute top-0 left-0 right-0 z-10 rotate-180">
            <svg viewBox="0 0 1440 150" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="w-full transform translate-y-1">
                <path d="M0 150L1440 150L1440 0C1440 0 1120 150 720 150C320 150 0 0 0 0L0 150Z"
                    class="fill-slate-50 dark:fill-gray-950" />
            </svg>
        </div> -->

        <!-- Nice Yellow Corner Animations -->
        <!-- Top Right -->
        <div class="absolute -top-20 -right-20 w-96 h-96 bg-secondary/30 rounded-full blur-3xl animate-pulse-slow">
        </div>
        <div class="absolute top-0 right-0 w-32 h-32 overflow-hidden pointer-events-none opacity-30">
            <div class="w-full h-full border-t-[12px] border-r-[12px] border-secondary  rounded-tr-3xl">
            </div>
        </div>

        <!-- Bottom Left -->
        <div
            class="absolute -bottom-20 -left-20 w-64 h-96 bg-secondary/30 rounded-full blur-3xl animate-pulse-slow delay-700">
        </div>
        <div class="absolute bottom-0 left-0 w-32 h-32 overflow-hidden pointer-events-none opacity-50">
            <div class="w-full h-full border-b-[12px] border-l-[12px] border-secondary rounded-bl-3xl">
            </div>
        </div>

        <!-- Decorative Animated Blobs (Softer for white theme) -->
        <div
            class="absolute top-1/2 left-1/4 w-[400px] h-[400px] bg-secondary/5 rounded-full blur-3xl opacity-40 animate-blob z-0">
        </div>

        <div class="container mx-auto px-4 relative z-20">
            <!-- Contact & Points of Sale Card -->


            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16"
                :class="isRtl ? 'rtl text-right' : 'ltr text-left'" :dir="isRtl ? 'rtl' : 'ltr'">
                <!-- Company Info -->
                <div class="col-span-1 md:col-span-2 lg:col-span-1 space-y-8"
                    :class="isRtl ? 'text-right' : 'text-left'">
                    <div>
                        <div class="inline-block p-6  mb-6 ">
                            <Logo max-width="140px" height="auto" />
                        </div>
                        <h3 class="text-3xl font-black mb-4 flex items-center gap-3 text-primary">
                            {{ setting.site_title && setting.site_title[locale] ? setting.site_title[locale] :
                                'AL-MATIN' }}
                        </h3>
                        <p class="text-gray-600 mb-8 leading-relaxed text-lg font-bold">
                            {{ footerDescription }}
                        </p>
                    </div>

                    <!-- Social Media Links -->
                    <div class="flex gap-4 flex-wrap">
                        <template v-for="(link, key) in socialLinks" :key="key">
                            <a v-if="setting[key]" :href="setting[key]" target="_blank"
                                class="w-14 h-14 rounded-2xl bg-slate-50 border border-gray-100 flex items-center justify-center text-primary hover:bg-secondary hover:text-primary hover:rotate-12 hover:scale-110 transition-all duration-500 shadow-xl shadow-primary/5 hover:shadow-secondary/30">
                                <v-icon size="28">{{ link.icon }}</v-icon>
                            </a>
                        </template>
                    </div>
                </div>

                <!-- Quick Links -->
                <div :class="isRtl ? 'text-right' : 'text-left'">
                    <div class="relative mb-8 group" :class="isRtl ? 'pr-6' : 'pl-6'">
                        <div class="absolute top-0 w-2 h-0 bg-secondary rounded-full group-hover:h-full transition-all duration-500 shadow-[0_0_20px_rgba(254,203,4,0.6)]"
                            :class="isRtl ? 'right-0' : 'left-0'">
                        </div>
                        <h4 class="text-2xl font-black text-primary">{{ __t('footer_quick_links') }}</h4>
                    </div>
                    <ul class="space-y-4">
                        <li v-for="item in displayMenu" :key="item.label">
                            <component :is="item.url && item.url.startsWith('http') ? 'a' : Link"
                                :href="getItemUrl(item)"
                                :target="item.url && item.url.startsWith('http') ? '_blank' : undefined"
                                class="text-gray-500 hover:text-primary flex items-center gap-3 transition-all duration-500 font-bold group"
                                :class="isRtl ? 'translate-x-0 hover:-translate-x-4' : 'translate-x-0 hover:translate-x-4'">
                                <span
                                    class="w-2.5 h-2.5 bg-secondary rounded-full opacity-0 group-hover:opacity-100 scale-0 group-hover:scale-100 transition-all shadow-lg shadow-secondary/50"></span>
                                {{ item.label }}
                            </component>
                        </li>
                    </ul>
                </div>

                <!-- Contact -->
                <div :class="isRtl ? 'text-right' : 'text-left'">
                    <div class="relative mb-8 group" :class="isRtl ? 'pr-6' : 'pl-6'">
                        <div class="absolute top-0 w-2 h-full bg-secondary rounded-full shadow-lg shadow-secondary/30"
                            :class="isRtl ? 'right-0' : 'left-0'">
                        </div>
                        <h4 class="text-2xl font-black text-primary">{{ __t('contact_us') }}</h4>
                    </div>
                    <ul class="space-y-6 text-gray-600">
                        <li class="flex items-start gap-4 group cursor-default">
                            <div
                                class="w-12 h-12 rounded-2xl bg-secondary/10 group-hover:bg-secondary group-hover:rotate-[360deg] flex items-center justify-center shrink-0 transition-all duration-700">
                                <span class="text-primary group-hover:text-white text-xl">📍</span>
                            </div>
                            <div>
                                <div class="text-gray-400 text-xs font-bold uppercase mb-1">{{
                                    __t('footer_address_title') }}</div>
                                <span
                                    class="font-bold text-lg pt-1 group-hover:text-primary transition-colors leading-tight block">
                                    {{ displayAddress }}
                                </span>
                            </div>
                        </li>
                        <li class="flex items-center gap-4 group cursor-default">
                            <div
                                class="w-12 h-12 rounded-2xl bg-secondary/10 group-hover:bg-secondary group-hover:rotate-[360deg] flex items-center justify-center shrink-0 transition-all duration-700">
                                <span class="text-primary group-hover:text-white text-xl">✉️</span>
                            </div>
                            <div>
                                <div class="text-gray-400 text-xs font-bold uppercase mb-1">{{ __t('footer_email_title')
                                    }}</div>
                                <span class="font-bold text-lg group-hover:text-primary transition-colors block">
                                    {{ displayEmail }}
                                </span>
                            </div>
                        </li>
                        <li class="flex items-center gap-4 group cursor-default">
                            <div
                                class="w-12 h-12 rounded-2xl bg-secondary/10 group-hover:bg-secondary group-hover:rotate-[360deg] flex items-center justify-center shrink-0 transition-all duration-700">
                                <span class="text-primary group-hover:text-white text-xl">📞</span>
                            </div>
                            <div>
                                <div class="text-gray-400 text-xs font-bold uppercase mb-1">{{ __t('footer_phone_title')
                                    }}</div>
                                <span class="font-bold text-lg group-hover:text-primary transition-colors block"
                                    dir="ltr" :class="isRtl ? 'text-right' : 'text-left'">
                                    {{ displayPhone }}
                                </span>
                            </div>
                        </li>
                        <li class="flex items-center gap-4 group cursor-default">
                            <div
                                class="w-12 h-12 rounded-2xl bg-secondary/10 group-hover:bg-secondary group-hover:rotate-[360deg] flex items-center justify-center shrink-0 transition-all duration-700">
                                <v-icon class="text-primary group-hover:text-white" size="24">mdi-web</v-icon>
                            </div>
                            <div>
                                <div class="text-gray-400 text-xs font-bold uppercase mb-1">{{
                                    __t('footer_website_title') }}</div>
                                <a href="https://www.almatin.com" target="_blank"
                                    class="font-bold text-lg group-hover:text-primary transition-all block">
                                    www.almatin.com
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- Vision Box -->
                <!-- <div :class="isRtl ? 'text-right' : 'text-left'" class="flex flex-col justify-center">
                    <div
                        class="bg-slate-50/80 backdrop-blur-md p-10 rounded-[3rem] border-2 border-white shadow-2xl overflow-hidden relative group hover:shadow-secondary/10 transition-all duration-700">
                        <div
                            class="absolute -top-12 -left-12 w-40 h-40 bg-secondary/20 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-1000">
                        </div>

                        <div class="absolute top-0 w-16 h-16 pointer-events-none" :class="isRtl ? 'left-0' : 'right-0'">
                            <div class="w-full h-full border-t-8 border-secondary/20"
                                :class="isRtl ? 'border-l-8 rounded-tl-[2.5rem]' : 'border-r-8 rounded-tr-[2.5rem]'">
                            </div>
                        </div>

                        <p
                            class="text-gray-600 text-lg leading-[1.8] font-bold italic relative z-10 flex items-center gap-3">
                            <span class="w-2 h-2 bg-secondary rounded-full animate-ping shrink-0"></span>
                            {{ __t('home_experience_text') }}
                        </p>
                    </div>
                </div> -->
                <div data-aos="fade-up" data-aos-delay="500" class="col-span-1 relative mb-10"
                    :class="isRtl ? 'text-right' : 'text-left'">
                    <div class="bg-secondary px-8 py-3 inline-block shadow-lg experience-badge">
                        <p class="font-black text-primary text-xl md:text-2xl rtl:lg:text-3xl whitespace-nowrap">
                            {{ __t('hero_badge_text') }}
                        </p>
                    </div>
                    <!-- Double border decoration -->
                    <div class="absolute -top-[7px] w-full h-full border-2 max-h-10 max-w-[250px] border-secondary pointer-events-none"
                        :class="isRtl ? '-right-[5px]' : '-left-[5px]'">
                    </div>
                </div>
            </div>

            <div class="border-t border-gray-100 pt-10 flex flex-col md:flex-row justify-between items-center text-gray-400 text-base font-bold"
                :class="isRtl ? 'rtl' : 'ltr'" :dir="isRtl ? 'rtl' : 'ltr'">
                <p>&copy; {{ new Date().getFullYear() }} {{ setting.site_title && setting.site_title[locale]
                    ? setting.site_title[locale] : 'AL-MATIN' }}. {{ __t('footer_copyright') }}</p>
                <div class="flex gap-10 mt-6 md:mt-0">
                    <Link v-if="route().has('privacy-policy')" :href="route('privacy-policy')"
                        class="text-gray-400 hover:text-primary flex items-center gap-2 group transition-all">
                        <span
                            class="w-1.5 h-1.5 bg-secondary rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                        {{ __t('privacy_policy') || 'Privacy Policy' }}
                    </Link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { Link, usePage } from '@inertiajs/vue3'
import { inject, computed, ref, onMounted } from 'vue'
import Logo from "@/Components/AdminLayout/logo/HomeLogo.vue";

const __t = inject('__t')
const page = usePage()
const setting = computed(() => page.props.setting || {})
const locale = computed(() => page.props.locale || 'en')
const isRtl = computed(() => locale.value === 'ar')

const footerDescription = computed(() => {
    if (setting.value.site_description && setting.value.site_description[locale.value]) {
        return setting.value.site_description[locale.value];
    }
    return __t('footer_description_default');
});

const displayAddress = computed(() => setting.value.address || __t('footer_address_value'));
const displayEmail = computed(() => setting.value.email_address || __t('footer_email_value'));
const displayPhone = computed(() => setting.value.phone || __t('footer_phone_value'));

// Default static menu
const quickLinks = computed(() => [
    { label: __t('nav_home'), url: 'home' },
    { label: __t('nav_about'), url: 'about' },
    { label: __t('nav_products'), url: 'products' },
    { label: __t('iso-certifications'), url: 'iso-certifications' },
    { label: __t('nav_blog'), url: 'blog' },
    { label: __t('nav_contact'), url: 'contact' },
    { label: __t('privacy_policy'), url: 'privacy-policy' },
])

const navMenu = ref([]);
const loading = ref(true);

const displayMenu = computed(() => {
    if (navMenu.value.length > 0) {
        return navMenu.value.map(item => ({
            label: item.lable[locale.value], // Note: API seems to use 'lable' typo based on reference
            url: item.url,
            // child: item.child
        }));
    }
    return quickLinks.value;
});

const getItemUrl = (item) => {
    if (!item.url) return '#';
    // If it's a route name
    if (route().has(item.url)) {
        return route(item.url);
    }
    return item.url;
}

const socialLinks = {
    facebook: { icon: 'mdi-facebook' },
    twitter: { icon: 'mdi-twitter' },
    instagram: { icon: 'mdi-instagram' },
    linkedin: { icon: 'mdi-linkedin' },
    youtube: { icon: 'mdi-youtube' },
    whatsapp: { icon: 'mdi-whatsapp' }
}

onMounted(() => {
    if (setting.value.menuFooter) {
        axios
            .get(route("api.menu", setting.value.menuFooter))
            .then((data) => {
                navMenu.value = data.data.menu.items;
            })
            .catch((error) => {
                console.error("Failed to fetch footer menu", error);
            })
            .finally(() => {
                loading.value = false;
            });
    } else {
        loading.value = false;
    }
});
</script>

<style scoped>
@keyframes corner-expand {

    0%,
    100% {
        width: 0%;
        height: 0%;
        opacity: 0;
    }

    50% {
        width: 100%;
        height: 100%;
        opacity: 1;
    }
}

@keyframes pulse-slow {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(1);
    }

    50% {
        opacity: 0.6;
        transform: scale(1.1);
    }
}

.animate-corner-expand {
    animation: corner-expand 6s ease-in-out infinite;
}

.animate-corner-expand-delay {
    animation: corner-expand 6s ease-in-out infinite 3s;
}

.animate-pulse-slow {
    animation: pulse-slow 8s ease-in-out infinite;
}

@keyframes blob {
    0% {
        transform: translate(0px, 0px) scale(1);
    }

    33% {
        transform: translate(30px, -50px) scale(1.1);
    }

    66% {
        transform: translate(-20px, 20px) scale(0.9);
    }

    100% {
        transform: translate(0px, 0px) scale(1);
    }
}

.animate-blob {
    animation: blob 10s infinite;
}

.animation-delay-2000 {
    animation-delay: 2s;
}

/* RTL Adjustments for translations */
.rtl {
    direction: rtl;
}

.experience-badge {
    position: relative;
    z-index: 1;
}
</style>
